module.exports = __webpack_public_path__ + "img/parallax2-1920p.7e6b25c8.jpg";